import React, { FC, ReactEventHandler } from 'react'
import { useSelector } from 'react-redux'
import './NextButton.scss'
import { IntegrationType } from '../../@types/config'
import { Button } from '../styled/CosmaButton/CosmaButton'
import { ReduxState } from '../../store/reducers'

const tinyColor = require('tinycolor2')

type NextButtonProps = {
  buttonText?: string
  onClick?: ReactEventHandler
  dataTestingButton?: string
  buttonAppearance?: 'primary' | 'secondary' | 'ghost' | 'inverted' | undefined
  disabled?: boolean
  responsive?: boolean
  customClasses?: string
} & JSX.IntrinsicElements['button']

const NextButton: FC<NextButtonProps> = ({
  buttonText = 'Weiter',
  onClick = () => {},
  dataTestingButton,
  buttonAppearance = 'secondary',
  disabled = false,
  responsive,
  customClasses,
}) => {
  const {
    config: { integrationType, theme },
  } = useSelector((state: ReduxState) => state)
  const isIv24Integration = integrationType === IntegrationType.IMMOVERKAUF24

  return (
    <div className={`grid grid-flex grid-justify-center ${customClasses || ''}`}>
      <div
        className={`grid-item align-center padding-horizontal-l ${
          responsive ? 'palm-one-whole lap-one-whole desk-one-third' : ''
        }`}
      >
        <Button
          className={`${isIv24Integration ? `iv24-btn` : `btn`}`}
          data-testing={dataTestingButton}
          appearance={buttonAppearance}
          onClick={onClick}
          disabled={disabled}
          data-testid={dataTestingButton}
          primary={theme.primary}
          secondary={theme.secondary}
          textColor={
            (integrationType === IntegrationType.EXTERNAL || integrationType === IntegrationType.IMMOVERKAUF24) &&
            !disabled &&
            tinyColor(theme.primary).isDark()
              ? '#FFFFFF'
              : theme.text
          }
          secondaryLight={theme.secondaryLight}
          iv24BackgroundColor={isIv24Integration ? theme.secondary : ''}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  )
}

export default NextButton
